import { getMessages } from '../../../../../../store/constants';

export const SNACKBAR_BOARD_MOVE_ID = 'SNACKBAR_BOARD_MOVE_ID';
export const SNACKBAR_MOVE_PROMT_TITLE = getMessages().getText('open_boards.snackbar.move.promt.title');
export const SNACKBAR_MOVE_PROMT_TEXT = getMessages().getText('open_boards.snackbar.move.promt.text');
export const SNACKBAR_MOVE_PROGRESS_TITLE = getMessages().getText('open_boards.snackbar.move.progress.title');
export const SNACKBAR_MOVE_PROGRESS_TEXT = getMessages().getText('open_boards.snackbar.move.progress.text');
export const SNACKBAR_MOVE_SUCCESS_TITLE = 'open_boards.snackbar.move.success.title';
export const SNACKBAR_MOVE_SUCCESS_TEXT = 'open_boards.snackbar.move.success.text';
